
import { useAuthRedirect } from '@/hooks/useAuthRedirect';

interface OnboardingGuardProps {
  children: React.ReactNode;
}

const OnboardingGuard = ({ children }: OnboardingGuardProps) => {
  const { authLoading, profileLoading, isAuthenticated, isOnboarded } = useAuthRedirect();

  if (authLoading || profileLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-emerald-50">
        <div className="text-center">
          <div className="text-lg text-green-700">Loading...</div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !isOnboarded) {
    return null; // useAuthRedirect already handles navigation
  }

  return <>{children}</>;
};

export default OnboardingGuard;
